/// <amd-module name="Feed/Legacy/Components/PackageVersionDetails" />
import * as React from "react";

import { FeedView, Package, PackageVersionMetrics, PackageVersion, PackageMetrics } from "Feed/Common/Contracts/Feed";
import * as PackageResources from "Feed/Common/Resources";
import { IPackageFollowState } from "Feed/Common/Types/IPackageFollowState";
import { LoadingContainer } from "Feed/Legacy/Components/LoadingContainer";
import { IPackageProtocol } from "Feed/Legacy/Protocols/Common/IPackageProtocol";
import { Feed } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";

export interface IPackageVersionDetailsProps {
    feed: Feed;
    feedViews: FeedView[];
    selectedPackage: Package;
    packageVersion: PackageVersion;
    protocolMap: { [key: string]: IPackageProtocol };
    packageFollowState: IPackageFollowState;
    isMetricsLoading: boolean;
    isPackageModifiedLoading: boolean;
    packageVersionMetrics: PackageVersionMetrics;
    packageMetrics: PackageMetrics;
    isSmartDependenciesEnabled: boolean;
    isProvenanceEnabled: boolean;
    isMetricsEnabled: boolean;
}

export class PackageVersionDetails extends React.PureComponent<IPackageVersionDetailsProps> {
    public render(): JSX.Element {
        const props = this.props;
        const protocol = props.protocolMap[props.selectedPackage.protocolType];
        const overviewContentPanel = protocol.getOverviewContentPanel(
            props.feed,
            props.feedViews,
            props.selectedPackage,
            props.packageVersion
        );
        const overviewAttributesPanel = protocol.getOverviewAttributesPanel(
            props.feed,
            props.selectedPackage,
            props.packageVersion,
            props.packageVersionMetrics,
            props.packageMetrics,
            props.isSmartDependenciesEnabled,
            props.isProvenanceEnabled,
            props.isMetricsEnabled,
            props.isMetricsLoading
        );

        return (
            <div className="package-version-details">
                <LoadingContainer isLoading={props.isPackageModifiedLoading}>
                    <div className="package-details-content">
                        <section
                            className="package-overview-content"
                            aria-label={PackageResources.AriaLabel_PackageOverview}
                        >
                            {overviewContentPanel}
                        </section>
                        <section
                            className="package-overview-attributes"
                            aria-label={PackageResources.AriaLabel_PackageAttributes}
                        >
                            {overviewAttributesPanel}
                        </section>
                    </div>
                </LoadingContainer>
            </div>
        );
    }
}
